import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { CommodityDetail } from "features/contracts/enums/commodityDetail"
import { ColorClassSuffix } from "features/shared/enums/colorClassSuffix";

export const containsFuelingCommodity = (commodityDetails: CommodityDetail[]): boolean => {
  const fuelingCommodityDetails: CommodityDetail[] = ["eMobility", "CNG"];
  
  if (commodityDetails) {
    for (const fuelingDetail of fuelingCommodityDetails) {
      let findElem = commodityDetails.find((commodityDetail) => commodityDetail == fuelingDetail);
      if (findElem !== undefined) {
        return true;
      }
    }
  }

  return false;
}

export const getCommodityColorSuffix = (commodityDetail: CommodityDetail, isProduction?: boolean): ColorClassSuffix => {
  switch (commodityDetail) {
    case "ElectricityCustomer":
    case "ElectricitySupplier":
      return isProduction ? ColorClassSuffix.Production : ColorClassSuffix.Electricity;
    case "GasCustomer":
    case "GasSupplier":
      return ColorClassSuffix.Gas;
    case "HeatCustomer":
      return ColorClassSuffix.Heat
    case "eMobility":
      return ColorClassSuffix.Emobility
    default:
      return ColorClassSuffix.Default;
  }
}

export const getCommodityIcon = (commodityDetail: CommodityDetail): IconProp => {
  switch (commodityDetail) {
    case "ElectricityCustomer":
    case "ElectricitySupplier":
      return "bolt";
    case "GasCustomer":
    case "GasSupplier":
      return "fire";
    case "HeatCustomer":
      return "thermometer-three-quarters";
    case "eMobility":
      return "charging-station";
    default:
      return "file-alt";
  }
}